import React, { Component } from 'react';
import Search from './Search';
import TransactionTable from './TransactionTable';



export default class TransactionPage extends Component {

    render() {
        return (
            <div>
                <br></br>
                <div className="search-pane">
                    <Search />
                    <br></br>
                    <br></br>
                    <TransactionTable />
                </div>
            </div>
        );
    }
}
